import { serviceHandler } from './service-executor';

const CHECK_URL = '/api/remittance';

export const getRemittanceInformation = (remittanceType, id, isOTR) => {
  remittanceType = remittanceType.toUpperCase();
  let URL = `${CHECK_URL}/${remittanceType}/${id}?isOTR=${isOTR}`;
  return serviceHandler(URL, 'GET');
};
